// extracted by mini-css-extract-plugin
module.exports = {"input":"useStudentPicker__input__6CPVP"};